import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Loading, StatCard } from "@/components/common";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { LayoutGrid, Boxes, CheckCircle2, AlertTriangle, FileText, Hourglass, Calculator } from "lucide-react";

export default function CostingDashboard() {
  const { can } = useAuth();
  const nav = useNavigate();
  const [d, setD] = useState(null);
  const [settings, setSettings] = useState(null);

  const load = () => {
    api.get("/costing/dashboard").then((r) => setD(r.data));
    api.get("/costing/settings").then((r) => setSettings(r.data));
  };
  useEffect(load, []);

  const changeMethod = async (m) => {
    try { await api.put("/costing/settings", { accounting_hpp_method: m }); toast.success(`Kebijakan HPP Akuntansi: ${m}`); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  if (!d) return <Loading />;
  return (
    <div>
      <PageHeader title="Dashboard HPP / Costing" subtitle="Ringkasan status HPP per SKU, versi menunggu approval, dan transaksi menunggu jurnal HPP." testId="costing-dashboard-header">
        <button onClick={() => nav("/costing/calculator")} className="inline-flex items-center gap-1.5 rounded-lg bg-indigo-600 px-3 py-2 text-sm font-medium text-white hover:bg-indigo-500" data-testid="go-calculator"><Calculator className="h-4 w-4" />Kalkulator HPP</button>
      </PageHeader>

      <div className="mb-6 rounded-xl border border-slate-200 bg-white p-4 shadow-sm flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">Kebijakan HPP Aktif untuk Akuntansi (Global)</p>
          <p className="text-sm text-slate-600">Default SPH: <b>HPP Dasar</b> sampai komponen HPP Full lengkap & disetujui.</p>
        </div>
        <Select value={settings?.accounting_hpp_method} onValueChange={changeMethod} disabled={!can("costing.approve")}>
          <SelectTrigger className="w-44" data-testid="accounting-method-select"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="DASAR">HPP Dasar</SelectItem><SelectItem value="FULL">HPP Full</SelectItem></SelectContent>
        </Select>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
        <StatCard label="Total Global SKU" value={d.total_sku} icon={Boxes} accent="indigo" testId="dash-total-sku" />
        <StatCard label="SKU HPP Dasar Approved" value={d.sku_dasar_approved} icon={CheckCircle2} accent="emerald" />
        <StatCard label="SKU Tanpa HPP Dasar" value={d.sku_tanpa_dasar} icon={AlertTriangle} accent="rose" />
        <StatCard label="SKU HPP Full Approved" value={d.sku_full_approved} icon={CheckCircle2} accent="sky" />
        <StatCard label="SKU HPP Full Belum Lengkap" value={d.sku_full_belum} icon={AlertTriangle} accent="amber" />
        <StatCard label="HPP Draft" value={d.hpp_draft} icon={FileText} accent="slate" />
        <StatCard label="HPP Menunggu Approval" value={d.hpp_menunggu_approval} icon={Hourglass} accent="amber" testId="dash-waiting-approval" />
        <StatCard label="Transaksi Menunggu HPP" value={d.transaksi_menunggu_hpp} icon={Hourglass} accent="rose" testId="dash-waiting-hpp" />
        <StatCard label="Jurnal HPP Draft" value={d.jurnal_hpp_draft} icon={LayoutGrid} accent="indigo" />
      </div>
    </div>
  );
}
